import { render, staticRenderFns } from "./diaspora.vue?vue&type=template&id=a699a9ac&scoped=true"
import script from "./diaspora.vue?vue&type=script&lang=js"
export * from "./diaspora.vue?vue&type=script&lang=js"
import style0 from "./diaspora.vue?vue&type=style&index=0&id=a699a9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a699a9ac",
  null
  
)

export default component.exports